import { AutomationRuleTriggerApiInterface } from 'src/editor/shared/types/automation-rules/triggers-types'

export const getAutomationRuleTriggerFromApi = (
  trigger: AutomationRuleTriggerApiInterface,
) => {
  const formId =
    trigger.funnelStep?.form?.id ??
    trigger.website?.websitePage?.form?.id ??
    undefined
  return {
    id: trigger.id,
    type: trigger.type,
    buttonId: trigger.buttonId ?? undefined,
    checkBoxId: trigger.checkBoxId ?? undefined,
    formId: formId,
  }
}
